import { render } from "./StudentPickupModal.vue?vue&type=template&id=d902a56a"
import script from "./StudentPickupModal.vue?vue&type=script&lang=js"
export * from "./StudentPickupModal.vue?vue&type=script&lang=js"

import "./StudentPickupModal.vue?vue&type=style&index=0&id=d902a56a&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__